import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data considered fresh
      cacheTime: 15 * 60 * 1000, // 15 minutes - time in cache
      refetchOnWindowFocus: false, // Don't refetch when window gains focus
      refetchOnReconnect: true, // Refetch when reconnecting
      retry: 2, // Number of attempts in case of error
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
      enabled: true, // Queries enabled by default
    },
    mutations: {
      retry: 1, // Mutations have fewer attempts
      retryDelay: 1000,
    },
  },
});

export default queryClient;
